import {
  TransferDiv,
  TransferText,
  TransferTitleText,
} from '../styles/LocalPaymentOptions.styles';

export const TransferDivComponent = () => {
  return (
    <TransferDiv>
      <TransferTitleText>Datos transferencia</TransferTitleText>
      <TransferText>Nombre: MEDICAL KIT SPA</TransferText>
      <TransferText>RUT: 77.143.138-0</TransferText>
      <TransferText>Banco: BCI</TransferText>
      <TransferText>Cuenta Cte N°: 46193499</TransferText>
      <TransferText>Correo electrónico: PAGOS@MIMEKI.CL</TransferText>
    </TransferDiv>
  );
};
